<script setup lang="ts">
import { computed } from 'vue'

const props = defineProps<{
  title: string
  description: string
  location: string
  startDate: string // ISO string or similar
  endDate?: string
}>()

const googleCalendarUrl = computed(() => {
  const start = new Date(props.startDate).toISOString().replace(/-|:|\.\d\d\d/g, '')
  // Default to 2 hours if no end date
  const end = props.endDate 
    ? new Date(props.endDate).toISOString().replace(/-|:|\.\d\d\d/g, '')
    : new Date(new Date(props.startDate).getTime() + 2 * 60 * 60 * 1000).toISOString().replace(/-|:|\.\d\d\d/g, '')
  
  const params = new URLSearchParams({
    action: 'TEMPLATE',
    text: `[OXO] ${props.title}`,
    details: props.description,
    location: props.location,
    dates: `${start}/${end}`
  })

  return `https://calendar.google.com/calendar/render?${params.toString()}`
})

const downloadIcs = () => {
  const start = new Date(props.startDate).toISOString().replace(/-|:|\.\d\d\d/g, '')
  const end = props.endDate 
    ? new Date(props.endDate).toISOString().replace(/-|:|\.\d\d\d/g, '')
    : new Date(new Date(props.startDate).getTime() + 2 * 60 * 60 * 1000).toISOString().replace(/-|:|\.\d\d\d/g, '')

  const icsContent = `BEGIN:VCALENDAR
VERSION:2.0
PRODID:-//OXO School//Events//FR
BEGIN:VEVENT
UID:${Date.now()}@oxo-school.com
DTSTAMP:${start}
DTSTART:${start}
DTEND:${end}
SUMMARY:[OXO] ${props.title}
DESCRIPTION:${props.description}
LOCATION:${props.location}
END:VEVENT
END:VCALENDAR`

  const blob = new Blob([icsContent], { type: 'text/calendar;charset=utf-8' })
  const link = document.createElement('a')
  link.href = window.URL.createObjectURL(blob)
  link.setAttribute('download', `${props.title.replace(/\s+/g, '_')}.ics`)
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
}
</script>

<template>
  <div class="flex flex-col sm:flex-row gap-3">
    <a 
      :href="googleCalendarUrl" 
      target="_blank"
      class="inline-flex items-center justify-center px-4 py-2 bg-oxo-card-bg border border-oxo-border rounded-lg text-sm font-bold text-foreground-dim hover:bg-oxo-card-bg/80 transition-colors gap-2"
    >
      <i class="fab fa-google" aria-hidden="true"></i> Google Calendar
    </a>
    <button 
      @click="downloadIcs"
      class="inline-flex items-center justify-center px-4 py-2 bg-oxo-card-bg border border-oxo-border rounded-lg text-sm font-bold text-foreground-dim hover:bg-oxo-card-bg/80 transition-colors gap-2"
    >
      <i class="far fa-calendar-plus" aria-hidden="true"></i> Outlook / Apple (.ics)
    </button>
  </div>
</template>
